import { render, staticRenderFns } from "./wt-radio.vue?vue&type=template&id=608f3014"
import script from "./wt-radio.vue?vue&type=script&lang=js"
export * from "./wt-radio.vue?vue&type=script&lang=js"
import style0 from "./wt-radio.vue?vue&type=style&index=0&id=608f3014&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports